import React, { useContext } from 'react';
import { BaseContext } from '../contexts/baseContext';

import img from '../../docs/fondGris.png';
import photo from '../../docs/renard3.png';

function ProfileContact() {
  const { navigateTo, profilSectionHeight } = useContext(BaseContext);


  return (
    <>
      <section className="profil-header">
        <div className="profil-header--image">
          <div className="profil-header--icon-control">
            <div className="backgroun-icon">
              <i className="bi bi-arrow-left-short" onClick={() => navigateTo("contacts")}></i>
            </div>

            <div className="backgroun-icon">
              <i className="bi bi-three-dots-vertical"></i>
            </div>
          </div>
          <img src={img} alt="profil" data-src={ photo }/>

          <div className="profil-header--info">
            <span> Donald </span>
            <small>online</small>
          </div>
        </div>
      </section>
      <section className="profil-body" style={{ height: `${profilSectionHeight}px` }}>
        <div className="profil-body--info">
          <article className="profil-item">
            <div className="profil-item--numero">
              <span>+23765087323</span>
              <span>Phone number</span>
            </div>

            <i className="bi bi-chat-right-text-fill conversation-icon"></i>
          </article>
          <article className="profil-item">
            <div className="profil-item--bio">
              <span>Bio</span>
              <span>a short description of me...</span>
            </div>
          </article>
        </div>
      </section>
    </>
  );
}

export default ProfileContact;
